import { browserSupportsWebAuthn, startAuthentication, startRegistration } from "@simplewebauthn/browser";
import "./styles.css";

const status = document.querySelector("#status");
const bootstrapForm = document.querySelector("#bootstrap-form");
const bootstrapEmail = document.querySelector("#bootstrap-email");
const bootstrapName = document.querySelector("#bootstrap-name");
const signinForm = document.querySelector("#signin-form");
const signinEmail = document.querySelector("#signin-email");
const signedIn = document.querySelector("#signed-in");
const sessionEmail = document.querySelector("#session-email");
const credentialCount = document.querySelector("#credential-count");
const sessionExpires = document.querySelector("#session-expires");
const appLogout = document.querySelector("#app-logout");

function show(message) {
  status.textContent = message;
}

function setVisible(element, visible) {
  element.classList.toggle("hidden", !visible);
}

async function api(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...(options.headers ?? {}),
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.detail || data.error || "Request failed.");
  return data;
}

async function refresh() {
  const data = await api("/api/status");
  setVisible(bootstrapForm, data.bootstrapAvailable && !data.authenticated);
  setVisible(signinForm, !data.bootstrapAvailable && !data.authenticated);
  setVisible(signedIn, data.authenticated);

  if (data.authenticated) {
    sessionEmail.textContent = data.session.email;
    credentialCount.textContent = String(data.session.credentialCount);
    sessionExpires.textContent = new Date(data.session.expiresAt).toLocaleString();
    show("Signed in with an app session.");
  } else if (data.bootstrapAvailable) {
    show("No local account exists yet. Create the first account and passkey.");
  } else {
    show("Local account exists. Sign in with your passkey.");
  }
}

bootstrapForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (!browserSupportsWebAuthn()) {
    show("This browser does not support WebAuthn.");
    return;
  }
  try {
    show("Creating passkey...");
    const email = bootstrapEmail.value.trim();
    const displayName = bootstrapName.value.trim();
    const options = await api("/api/bootstrap/options", {
      method: "POST",
      body: JSON.stringify({ email, displayName }),
    });
    const response = await startRegistration({ optionsJSON: options });
    await api("/api/bootstrap/verify", {
      method: "POST",
      body: JSON.stringify({
        email,
        displayName,
        bootstrapUserId: options.bootstrapUserId,
        challenge: options.challenge,
        response,
      }),
    });
    await refresh();
  } catch (error) {
    show(error.message);
  }
});

signinForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (!browserSupportsWebAuthn()) {
    show("This browser does not support WebAuthn.");
    return;
  }
  try {
    show("Waiting for passkey...");
    const email = signinEmail.value.trim();
    const options = await api("/api/authentication/options", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
    const response = await startAuthentication({ optionsJSON: options });
    await api("/api/authentication/verify", {
      method: "POST",
      body: JSON.stringify({ email, challenge: options.challenge, response }),
    });
    await refresh();
  } catch (error) {
    show(error.message);
  }
});

appLogout.addEventListener("click", async () => {
  await api("/api/logout", { method: "POST", body: "{}" });
  await refresh();
});

refresh().catch((error) => show(error.message));
